export default {
    validate(pa) {

        // 120/080 = Sistólica/Diastólica.

        if (typeof pa !== 'string' || !/^\d{1,3}\/\d{1,3}$/.test(pa)) {
            return 'A Pressão Arterial informada é inválida. Utilize o formato 000/000.'
        }

        const [sistolica, diastolica] = pa.split('/').map(Number)

        if (sistolica > 300) {
            return 'A pressão Sistólica deve ser menor ou igual a 300'
        }

        if (diastolica > 300) {
            return 'A pressão Diastólica deve ser menor ou igual a 300'
        }

        if (diastolica >= sistolica) {
            return 'A pressão Diastólica deve ser menor que a Sistólica'
        }

        return true
    },
}